import { normalizeRole } from '@/auth/permissions';

const CONSULTA_IDE_PRICES_VIEWERS = new Set(['main@sien.com']);

export const canAccessConsultaIdePrices = (email?: string | null, role?: string | null): boolean => {
  if (normalizeRole(role) !== 'CONSULTA') return false;
  if (!email) return false;
  return CONSULTA_IDE_PRICES_VIEWERS.has(email.trim().toLowerCase());
};

export const canAccessPrices = (email?: string | null, role?: string | null): boolean => {
  const normalized = normalizeRole(role);
  if (normalized === 'PROVEEDOR') return true;
  return canAccessConsultaIdePrices(email, role);
};
